import { isUndNullEmp } from '../../helpers/main.js';
const currentDateTimeISO = new Date()?.toISOString();

export class UserCompanyCustomer {
    constructor(
        _id = 0,
        _userId = '',
        _companyId = 0,
        _customerId = 0,
        _register = currentDateTimeISO,
    ) {
        this.id = _id;
        this.userId = _userId;
        this.companyId = _companyId;
        this.customerId = _customerId;
        this.register = _register;
    }

    static getClassName = () => {
        return 'UserCompanyCustomer - class';
    }

    static minMaxLength = (upperCase = false) => {
        if (upperCase) {
            return {
                min: {
                    Id: 1,
                    UserId: 10,
                    CompanyId: 1,
                    CustomerId: 1,
                    Register: 10,
                },
                max: {
                    Id: 450,
                    UserId: 450,
                    CompanyId: 450,
                    CustomerId: 450,
                    Register: 30,
                },
            };
        } else {
            return {
                min: {
                    id: 1,
                    userId: 10,
                    companyId: 1,
                    customerId: 1,
                    register: 10,
                },
                max: {
                    id: 450,
                    userId: 450,
                    companyId: 450,
                    customerId: 450,
                    register: 30,
                },
            };
        }
    }

    static getClass = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: UserCompanyCustomer.getClassName() })?.result) {
            if (upperCase) {
                return new UserCompanyCustomer(
                    obj.Id,
                    obj.UserId,
                    obj.CompanyId,
                    obj.CustomerId,
                    obj.Register,
                );
            } else {
                return new UserCompanyCustomer(
                    obj.id,
                    obj.userId,
                    obj.companyId,
                    obj.customerId,
                    obj.register,
                );
            }
        } else {
            return new UserCompanyCustomer();
        }
    }
}